<!--
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-06-24 13:38:05
 * @LastEditors: hongye
 * @LastEditTime: 2025-06-09 16:35:42
-->
<template>
  <div v-show="props.total" class="table-count">
    <span
      >{{ $lang('共') }}
      <span class="table-number">{{ props.total }}</span>
      {{ $lang('条数据') }}</span
    >
  </div>
</template>
<script lang="ts" setup>
  interface IProps {
    total: any
  }
  const props = defineProps<IProps>()
</script>
<style lang="less" scoped>
  .table-count {
    // margin-bottom: 16px;
    // margin-right: 20px;
    .table-number {
      color: @primary-color;
      font-weight: bold;
    }
  }
</style>
